// Images
export const MANAGEMENT_REACHING_OUT_IMG = "/images/sales-intelligence/reaching-out.svg";

export const SL_IMG_LISTS = "/images/sales-intelligence/suppression-list-img.svg";
export const SL_CONTACTS_IMG_LISTS = "/images/sales-intelligence/suppression-list-contacts-img.svg";

export const NO_ACCESS_IMG = "/images/sales-intelligence/management-no-access.svg";

export const TOOLTIP_TEXT_MAP = {
    Empty: { hubspot: "", salesforce: "", dynamics: "" },
    Failed: {
        hubspot: "si.management.hs.section.integration-status.failed.tooltip",
        salesforce: "si.management.sf.section.integration-status.failed.tooltip",
        dynamics: "si.management.dynamics.section.integration-status.failed.tooltip",
    },
    FailedUnauthorized: {
        hubspot: "si.management.hs.section.integration-status.failed-unauthorized.tooltip",
        salesforce: "si.management.sf.section.integration-status.failed-unauthorized.tooltip",
        dynamics: "si.management.dynamics.section.integration-status.failed-unauthorized.tooltip",
    },
    InProgress: {
        hubspot: "si.management.sf.section.integration-status.in-progress.tooltip",
        salesforce: "si.management.sf.section.integration-status.in-progress.tooltip",
        dynamics: "si.management.dynamics.section.integration-status.in-progress.tooltip",
    },
};

export enum INTEGRATION_STATUS {
    NotIntegrated = "NotIntegrated",
    Succeeded = "Succeeded",
    Failed = "Failed",
    InProgress = "InProgress",
    New = "New",
}

export const SYNC_FAILED_REASON_CODE_INSUFFICIENT_PERMISSIONS = 2;

export const LOGIN_LINKS = {
    salesforce: "/sales-api/sw-connector/salesforce/connect",
    hubspot: "/sales-api/sw-connector/hubspot/connect",
    dynamics: "/sales-api/sw-connector/microsoft-dynamics/connect",
};

export const RECONNECT_LINKS = {
    salesforce: "/sales-api/sw-connector/salesforce/change-owner",
    hubspot: "/sales-api/sw-connector/hubspot/change-owner",
    dynamics: "/sales-api/sw-connector/microsoft-dynamics/change-owner",
};

export const ONE_HOUR = 60;
export const ONE_DAY = 1440;

export const LOGIN_WIDTH = 600;
export const LOGIN_HEIGHT = 650;

const SF_HS_TERMS_AND_CONDITIONS_LINK =
    "https://www.similarweb.com/corp/legal/supplemental-terms-conditions-sales-intelligence";

export const INTEGRATION_TERMS = {
    salesforce: SF_HS_TERMS_AND_CONDITIONS_LINK,
    hubspot: SF_HS_TERMS_AND_CONDITIONS_LINK,
    dynamics: SF_HS_TERMS_AND_CONDITIONS_LINK,
};

export const INTEGRATION_IMAGE = {
    salesforce: "/images/sales-intelligence/salesforce-integration.svg",
    hubspot: "/images/sales-intelligence/hubspot-integration.svg",
    dynamics: "/images/sales-intelligence/dynamics-integration.svg",
};

